const data = {
  profile: {
    name: 'Amit Raut',
    role: 'Aspiring Software Developer | CSIT Graduate | Tech Enthusiast',
    tagline: 'Transforming ideas into efficient and scalable digital solutions.',
    avatar: 'image/profil.jpeg',
  },

  projects: [
    {
      id: 'p1',
      title: 'HomeCrafting Website',
      description:
        'A feature-rich platform designed to showcase, manage, and sell handcrafted products online. Includes item categorization, responsive layouts, and smooth navigation for creators and buyers.',
      stack: ['PHP', 'TailwindCSS', 'MySQL'],
      image: 'image/homecrafting.png',
      demo: '#',
      github: '#',
      category: 'php',
    },
    {
      id: 'p2',
      title: 'Home Rental Management System',
      description:
        'A comprehensive web-based application for listing, searching, and managing rental properties. Features tenant registration, property owner dashboards, and real-time booking management functionalities.',
      stack: ['PHP', 'MySQL', 'TailwindCSS'],
      image: 'image/home-rent.png',
      demo: '#',
      github: '#',
      category: 'php',
    },
    {
      id: 'p3',
      title: 'Personal Portfolio Website',
      description:
        'A modern, responsive personal portfolio built with ReactJS and TailwindCSS. Showcases projects, experience, and blogs with dark mode support and SEO optimization for better online presence.',
      stack: ['React', 'TailwindCSS', 'Framer Motion'],
      image: 'image/portfilo.png',
      demo: '#',
      github: '#',
      category: 'react',
    },
    {
      id: 'p4',
      title: 'Live Auction Platform (Concept)',
      description:
        'A conceptual design for a live auction website enabling real-time bidding interactions and dynamic updates using modern web technologies.',
      stack: ['Concept', 'Realtime'],
      image: 'image/auction.png',
      demo: '#',
      github: '#',
      category: 'concept',
    },
  ],

  experience: [
    {
      id: 'e1',
      role: 'Intern',
      company: 'Nepal Telecom',
      period: '2025',
      summary:
        'Gained hands-on experience in system analysis, documentation, and IT infrastructure. Collaborated with professionals on improving internal processes and implementing digital solutions.',
    },
    {
      id: 'e2',
      role: 'Academic Projects',
      company: 'Mahendra Multiple Campus',
      period: '2022 — 2025',
      summary:
        'Applied Object-Oriented Analysis (OOA) principles to design and develop multiple academic projects, emphasizing software architecture and web development.',
    },
  ],

  education: [
    {
      id: 'ed1',
      degree: 'B.Sc. in Computer Science and Information Technology (CSIT)',
      school: 'Mahendra Multiple Campus',
      supervisor: 'Keshav Poudel',
      graduation: '2025',
    },
  ],

  highlights: [
    'Completed internship at Nepal Telecom with a focus on system documentation and IT analysis.',
    'Developed multiple projects using PHP, ReactJS, TailwindCSS, and MySQL.',
    'Strong foundation in Object-Oriented Analysis (OOA) and software design principles.',
    'Interested in emerging technologies including Artificial Intelligence, Web Development, and System Architecture.',
  ],

  skills: {
    frontend: ['ReactJS', 'TailwindCSS', 'HTML', 'CSS', 'JavaScript'],
    backend: ['PHP', 'Node.js (Basic)', 'MySQL'],
    tools: ['Git & GitHub', 'XAMPP', 'Netlify', 'Vercel'],
    concepts: ['Object-Oriented Analysis', 'Database Design', 'System Analysis'],
  },

  blogs: [
    {
      id: 'b1',
      title: 'What I Learned During My Internship at Nepal Telecom',
      excerpt:
        'An in-depth reflection on hands-on learning, IT infrastructure, and system analysis during my internship at Nepal Telecom.',
      image:
        'https://images.unsplash.com/photo-1526378722484-bd91ca387e72?q=80&w=1200&auto=format&fit=crop',
      tags: ['internship', 'systems', 'career'],
      content: `
  Introduction
  
  Internships provide a bridge between academic learning and real-world experience. My internship at Nepal Telecom, one of Nepal's largest telecom organizations, offered a comprehensive view of IT operations, system analysis, and professional teamwork. Over several months, I engaged with various teams, learning the importance of structured processes and effective communication.
  
  Overview of Responsibilities
  
  During my internship, I worked on system documentation, network monitoring, data management, and collaborated with professional engineers. Documenting systems allowed me to understand workflows thoroughly, while handling network and database tasks provided hands-on exposure to real-world challenges.
  
  Key Learnings and Takeaways
  
  Understanding Structured Documentation
  Clear documentation is essential for maintaining and scaling systems. It ensures new team members can easily understand workflows and reduces the risk of errors.
  
  Applying Academic Knowledge in Real-World Settings
  Implementing classroom concepts in live systems revealed practical insights that cannot be gained from textbooks alone, especially in networking, databases, and IT operations.
  
  Developing Professional Soft Skills
  Participating in meetings and discussions honed my communication skills. Learning to explain technical concepts clearly is as important as executing them.
  
  Time Management and Prioritization
  Managing multiple tasks, meeting deadlines, and balancing different responsibilities reinforced the value of efficient time management.
  
  Challenges and How I Overcame Them
  
  Adapting to complex IT systems was initially overwhelming. Understanding multi-step workflows required patience. Collaborating with experienced professionals challenged me to communicate clearly and contribute effectively. Overcoming these obstacles enhanced my resilience and adaptability.
  
  Conclusion
  
  The internship was transformative, enhancing both my technical and professional abilities. It solidified my career interests in IT systems and software development. Future interns should actively document, ask questions, observe carefully, and embrace challenges as learning opportunities.
  `
    },
    {
      id: 'b2',
      title: 'How I Built My HomeCrafting Website Using PHP and TailwindCSS',
      excerpt:
        'A detailed walkthrough of developing a feature-rich platform for handcrafted products using modern web technologies.',
      image:
        'https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=1200&auto=format&fit=crop',
      tags: ['php', 'tailwind', 'web-development'],
      content: `
  Introduction
  
  The HomeCrafting website is a platform designed to showcase and manage handcrafted products online. Building this project allowed me to experience full-stack development using PHP for the backend, MySQL for database management, and TailwindCSS for a responsive user interface.
  
  Planning and Architecture
  
  Before writing any code, I designed the database schema to manage products, categories, users, and orders. The layout and styling were planned using TailwindCSS to ensure a responsive and modern look. Backend functionality in PHP handled user authentication, product listings, and order management.
  
  Development Process
  
  Frontend development with TailwindCSS enabled rapid prototyping and efficient styling. Backend development involved creating secure PHP scripts to handle data retrieval and storage. MySQL provided the backbone for structured and scalable data management.
  
  Challenges and Solutions
  
  Managing complex data relationships between users, products, and orders required careful planning. Designing a responsive and intuitive UI for both desktop and mobile devices was challenging but achievable with TailwindCSS. Debugging and testing across different scenarios ensured a smooth user experience.
  
  Key Takeaways
  
  Building HomeCrafting reinforced the importance of modular code, database design, and responsive UI. It highlighted how backend, frontend, and database layers interact seamlessly to create a functional product.
  
  Conclusion
  
  The project was not just a technical exercise but a reflection of my journey as a developer, learning to balance creativity, logic, and user experience in real-world applications.
  `
    },
    {
      id: 'b3',
      title: 'Why Object-Oriented Analysis Still Matters in 2025',
      excerpt:
        'Exploring the relevance of Object-Oriented Analysis in modern software design and scalable application development.',
      image:
        'https://images.unsplash.com/photo-1518779578993-ec3579fee39f?q=80&w=1200&auto=format&fit=crop',
      tags: ['analysis', 'software-design', 'ooa'],
      content: `
  Introduction
  
  Object-Oriented Analysis (OOA) is often considered an academic concept, yet it remains a cornerstone of software design. Its principles guide developers to create structured, maintainable, and scalable software systems.
  
  Core Principles and Benefits
  
  Encapsulation helps organize data and behavior within classes, ensuring clear responsibilities. Abstraction simplifies complex systems into understandable models. Inheritance and polymorphism promote code reusability and flexibility.
  
  Practical Applications
  
  Using OOA in projects helps with debugging, maintaining, and extending applications. It also improves collaboration by providing a clear blueprint for teams to follow. Even in modern frameworks like ReactJS or Laravel, OOA principles guide architecture and component design.
  
  Conclusion
  
  Object-Oriented Analysis bridges planning and execution. Applying its principles ensures software is structured, understandable, and maintainable, making it as relevant today as it has ever been.
  `
    },
    {
      id: 'b4',
      title: 'Building Scalable Web Applications: Tips and Techniques',
      excerpt:
        'Professional strategies for designing web applications that can handle increasing traffic and complex user demands efficiently.',
      image:
        'https://images.unsplash.com/photo-1508385082359-f6f0f0c1b09f?q=80&w=1200&auto=format&fit=crop',
      tags: ['web-development', 'scalability', 'performance'],
      content: `
  Introduction
  
  Scalable web applications are essential for businesses expecting growth. Scaling is not just about adding servers; it requires careful architecture, optimization, and continuous monitoring.
  
  Techniques for Scalability
  
  Caching frequently accessed data reduces server load. Database optimization, including indexes and query optimization, ensures efficient data handling. Modular architecture allows easy feature extension. Continuous monitoring helps identify bottlenecks before they impact performance.
  
  Best Practices
  
  Use content delivery networks for static assets. Optimize APIs for response time. Implement horizontal scaling to distribute load. Testing under load scenarios ensures readiness for traffic spikes.
  
  Conclusion
  
  Building scalable applications requires strategic planning, robust architecture, and ongoing optimization. Following best practices ensures applications remain reliable and performant as they grow.
  `
    },
    {
      id: 'b5',
      title: 'Why TailwindCSS Makes Modern UI Development Faster',
      excerpt:
        'An in-depth look at how TailwindCSS streamlines UI development and enhances front-end efficiency.',
      image:
        'https://images.unsplash.com/photo-1600185366505-6a8bfa3f65e8?q=80&w=1200&auto=format&fit=crop',
      tags: ['frontend', 'tailwind', 'ui-design'],
      content: `
  Introduction
  
  TailwindCSS is a utility-first framework that accelerates UI development. It allows developers to create responsive, clean, and maintainable interfaces without writing excessive custom CSS.
  
  Benefits and Usage
  
  TailwindCSS enables rapid prototyping, enforces consistent design patterns, and reduces CSS file size. Responsive grids, spacing utilities, and predefined classes simplify design implementation. Features like dark mode and theming are integrated, allowing developers to focus on functionality rather than CSS.
  
  Conclusion
  
  TailwindCSS is a valuable tool for modern front-end development. It allows developers to build visually appealing and responsive interfaces efficiently, saving time while maintaining flexibility.
  `
    },
    {
      id: 'b6',
      title: 'Getting Started with ReactJS for Modern Web Apps',
      excerpt:
        'A complete guide for beginners to understand ReactJS, component-based development, and building interactive frontends.',
      image:
        'https://images.unsplash.com/photo-1581091012184-1f30f8fa8a37?q=80&w=1200&auto=format&fit=crop',
      tags: ['react', 'frontend', 'web-app'],
      content: `
  Introduction
  
  ReactJS is a popular JavaScript library for building interactive, component-based user interfaces. Its modular architecture makes it ideal for scalable applications.
  
  Core Concepts
  
  Components and props serve as building blocks. State and hooks manage dynamic data and lifecycle events. Routing and context handle navigation and global state efficiently. Breaking down UI into smaller components improves maintainability and reusability.
  
  Practical Tips
  
  Keep components small and focused. Use hooks to manage state effectively. Modularize code for easier collaboration and testing.
  
  Conclusion
  
  Mastering ReactJS allows developers to create dynamic, scalable, and maintainable front-end applications suitable for modern web development.
  `
    },
    {
      id: 'b7',
      title: 'Optimizing MySQL Databases for Performance',
      excerpt:
        'Professional techniques to improve query performance, data management, and scalability in MySQL.',
      image:
        'https://images.unsplash.com/photo-1612832021023-2b7f22f1fa2d?q=80&w=1200&auto=format&fit=crop',
      tags: ['mysql', 'database', 'optimization'],
      content: `
  Introduction
  
  MySQL databases are critical for web applications. Optimizing performance ensures applications run smoothly, handle high traffic, and maintain reliability.
  
  Techniques
  
  Index frequently queried columns. Normalize tables to reduce redundancy. Analyze queries using EXPLAIN. Monitor slow queries and optimize them. Implement connection pooling to handle multiple requests efficiently.
  
  Best Practices
  
  Use appropriate storage engines. Archive old data to maintain performance. Regularly backup databases and monitor for anomalies.
  
  Conclusion
  
  Efficient database optimization improves application performance, scalability, and maintainability, forming the foundation for reliable web systems.
  `
    },
    {
      id: 'b8',
      title: 'Designing User-Friendly Interfaces for Web Apps',
      excerpt:
        'Insights into building intuitive, accessible, and aesthetically pleasing user interfaces for modern web applications.',
      image:
        'https://images.unsplash.com/photo-1581091012920-2f53bc5b1e9b?q=80&w=1200&auto=format&fit=crop',
      tags: ['ui', 'ux', 'design'],
      content: `
  Introduction
  
  User interface design is crucial in shaping user experience. A clear, consistent, and intuitive interface ensures users can interact effectively with applications.
  
  Principles
  
  Prioritize simplicity and clarity. Maintain consistent styling and spacing. Use whitespace strategically to reduce clutter. Ensure accessibility for all users, including those with disabilities. Test UI with real users to gain feedback.
  
  Best Practices
  
  Focus on readability and usability. Use responsive layouts to support multiple devices. Incorporate user feedback iteratively to refine the interface.
  
  Conclusion
  
  Thoughtful UI design enhances usability, accessibility, and user satisfaction, ultimately contributing to the success of a web application.
  `
    },
    {
      id: 'b9',
      title: 'Understanding Realtime Web Applications',
      excerpt:
        'Exploring real-time web applications, their use cases, and technologies behind dynamic, live-updating interfaces.',
      image:
        'https://images.unsplash.com/photo-1593642634315-48f5414c3ad9?q=80&w=1200&auto=format&fit=crop',
      tags: ['realtime', 'web-app', 'live'],
      content: `
  Introduction
  
  Realtime web applications allow data to be updated instantly across all connected users. Examples include live chat, collaborative editing, and live auctions.
  
  Core Concepts
  
  WebSockets enable two-way communication between clients and servers. Event-driven architectures help manage real-time data efficiently. Backend frameworks like Node.js support asynchronous operations essential for live updates.
  
  Use Cases
  
  Live chat systems, multiplayer games, financial dashboards, and online auctions all leverage real-time technologies. They enhance user engagement by providing immediate feedback and updates.
  
  Best Practices
  
  Optimize performance to prevent delays. Handle network interruptions gracefully. Ensure data consistency across clients. Use scalable architectures to support multiple concurrent connections.
  
  Conclusion
  
  Realtime applications provide a more interactive and engaging user experience, demanding both technical understanding and careful planning.
  `
    },
    {
      id: 'b10',
      title: 'Improving Web Application Security: Key Strategies',
      excerpt:
        'Comprehensive strategies to protect web applications from common threats and ensure data integrity and user safety.',
      image:
        'https://images.unsplash.com/photo-1591696205602-3455f8d022dd?q=80&w=1200&auto=format&fit=crop',
      tags: ['security', 'web-app', 'best-practices'],
      content: `
  Introduction
  
  Web application security is critical to protect user data, maintain trust, and comply with regulations. Understanding vulnerabilities and implementing best practices reduces risks.
  
  Key Strategies
  
  Validate and sanitize user inputs to prevent SQL injection and XSS attacks. Use HTTPS to encrypt data transmission. Implement strong authentication and authorization mechanisms. Regularly update dependencies to patch security vulnerabilities.
  
  Best Practices
  
  Perform security testing and audits regularly. Monitor application logs for suspicious activity. Educate development teams about security principles.
  
  Conclusion
  
  Strong web security practices ensure applications remain trustworthy, reliable, and resilient against threats, safeguarding both users and the organization.
  `
    },
  ]
  
    
};

export default data;
